module.exports = __webpack_public_path__ + "static/media/logoWithSlogen.9f37f2b8.png";